export const calculateTax = (income) => {
  let tax = 0;
  if (income <= 600) {
    tax = 0;
  } else if (income <= 1650) {
    tax = income * 0.1 - 60;
  } else if (income <= 3200) {
    tax = income * 0.15 - 142.5;
  } else if (income <= 5250) {
    tax = income * 0.2 - 302.5;
  } else if (income <= 7800) {
    tax = income * 0.25 - 565;
  } else if (income <= 10900) {
    tax = income * 0.3 - 955;
  } else {
    tax = income * 0.35 - 1500;
  }

  tax = tax.toFixed(2);
  return parseFloat(tax);
};
